define('plugin/news/view/NewsModuleView',['require','plugin/news/view/NewsIndexView','plugin/news/view/NewsModuleItemView'],function (require) {

    var NewsIndexView = require('plugin/news/view/NewsIndexView');
    var NewsModuleItemView = require('plugin/news/view/NewsModuleItemView');

    /**
     * News module view (news container)
     *
     * @class NewsModuleView
     */
    return NewsIndexView.extend({

        template: '#news_list_module_view',
        childView: NewsModuleItemView,
        childViewContainer: '#sb_news_list_module_container',
        collectionEvents: {
            sync: 'render'
        },

        onDomRefresh: function () {
            Backbone.Wreqr.radio.vent.trigger('module', 'shown', {
                'module': 'news'
            });
        }

    });

});
